import React, { useState, useEffect } from "react";
import {
  Select,
  Form,
  Input,
  Button,
  Upload,
  Row,
  DatePicker,
  message,
  Cascader,
  Descriptions,
  Tag,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import AddModal from "@components/Modal";
import InspectionApi from "@api/inspectionnew";
import DepartmentApi from "@api/department";
import {
  findAllParents,
  defectStatusColor,
  defectStatus,
  disabledDate,
  disabledTime,
} from "@utils/common";

const { RangePicker } = DatePicker;

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
export default ({ title, visible, rowData = {}, cancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState();
  const [deptList, setDeptList] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [personList, setPersonList] = useState([]);
  const [timeLimit, setTimeLimit] = useState([]);

  useEffect(() => {
    getDept();
  }, [visible]);

  useEffect(() => {
    if (rowData.createAt) {
      setTimeLimit([rowData.createAt, rowData.planCloseTime]);
    }
  }, [rowData]);

  const getDept = async () => {
    const res = await DepartmentApi.getDeptForTree({});
    if (!res.status) return;
    setDeptList(res.data);
    if (rowData.deptId) {
      const ids = findAllParents(
        res.data,
        rowData.deptId,
        [],
        "string",
        "children",
      );
      form.setFieldsValue({
        deptId: ids,
      });
      changeDept(ids);
    }
  };

  // 切换部门查询部门负责人
  const changeDept = (e) => {
    if (!e) return;
    getUsers(e[e.length - 1]);
  };
  const getUsers = (deptId) => {
    DepartmentApi.getUsersByDeptId({
      deptId,
      stationId: rowData.stationId,
    }).then((res) => {
      if (res.status !== "0") return;
      setPersonList(res.data);
    });
  };

  // 提交
  const submit = () => {
    form.validateFields().then((values) => {
      if (!values) return;
      setLoading(true);
      let param = {
        beginTime: moment(values.time[0]).format("YYYY-MM-DD HH:mm:ss"),
        endTime: moment(values.time[1]).format("YYYY-MM-DD HH:mm:ss"),
        handleUserIds: values.handleUserIds,
        workOrderContent: values.workOrderContent,
        workOrderTitle: values.workOrderTitle,
        defectOrderId: rowData.id,
        deptId: values.deptId.at(-1),
        imageUrls,
      };
      InspectionApi.defectOrderWorkOrderAdd(param)
        .then((res) => {
          if (res.status == 0) {
            message.success("新增成功");
            handelCancel(true);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    });
  };

  // 上传前进行图片限制处理
  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === "image/jpg" ||
      file.type === "image/jpeg" ||
      file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("图片格式不正确!");
    }
    const isLt2M = file.size / 1024 / 1024 < 7;
    if (!isLt2M) {
      message.error("图片最大7M!");
    }
    return isJpgOrPng && isLt2M;
  };

  const uploadResultImg = (info) => {
    const { file } = info;
    if (file.status === "done") {
      const { response: res } = file;
      if (res.status !== "0") return;
      setImageUrls([...imageUrls, res.data.url]);
    }
  };

  const removeResultImg = (info) => {
    const { response: res } = info;
    const url = res.data.url;
    const params = imageUrls;
    const index = params.findIndex((item) => item === url);
    params.splice(index, 1);
    setImageUrls([...params]);
  };

  // 取消
  const handelCancel = (bool) => {
    form.resetFields();
    cancel(bool);
  };

  return (
    <AddModal
      title={title}
      footer={[
        <Row key={"btn"} span={24}>
          <Button
            key={1}
            onClick={() => handelCancel(false)}
            className="abuttons"
          >
            <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
          </Button>
          <Button
            key={2}
            loading={loading}
            onClick={submit}
            className="abuttons"
            type="primary"
          >
            <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
          </Button>
        </Row>,
      ]}
      visible={visible}
      width={700}
      okText={"确定"}
      onCancel={() => handelCancel(false)}
      onSubmit={() => submit()}
    >
      <Descriptions title="缺陷单基础信息">
        <Descriptions.Item label="缺陷等级">
          {rowData.defectLevelName}
        </Descriptions.Item>
        <Descriptions.Item label="缺陷描述">
          {rowData.deffectRemark}
        </Descriptions.Item>
        <Descriptions.Item label="所属厂站">
          {rowData.stationName}
        </Descriptions.Item>
        <Descriptions.Item label="所属部门">
          {rowData.deptName}
        </Descriptions.Item>
        <Descriptions.Item label="部门负责人">
          {rowData.deptLeaderName}
        </Descriptions.Item>
        <Descriptions.Item label="设备名称">
          {rowData.deviceRelevancyName}
        </Descriptions.Item>
        <Descriptions.Item label="状态">
          <Tag color={defectStatusColor(rowData.handleStatus - 0)}>
            {defectStatus(rowData.handleStatus - 0)}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="超时状态">
          {rowData.timeoutStatus == 1 ? (
            <Tag color="#FF3819">超时</Tag>
          ) : (
            <Tag color="#2db7f5">未超时</Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="安全隐患">
          {rowData.safetyPerilFlag ? "是" : "否"}
        </Descriptions.Item>
        <Descriptions.Item label="发现时间">
          {rowData.discoveryTime}
        </Descriptions.Item>
        <Descriptions.Item label="创建时间">
          {rowData.createAt}
        </Descriptions.Item>
        <Descriptions.Item label="计划关闭时间">
          {rowData.planCloseTime}
        </Descriptions.Item>
      </Descriptions>
      <Form {...layout} form={form}>
        <Form.Item
          label="工单标题"
          name="workOrderTitle"
          rules={[{ required: true, message: "请输入工单标题!" }]}
        >
          <Input placeholder="请输入工单标题"></Input>
        </Form.Item>
        <Form.Item
          label="负责部门"
          name="deptId"
          rules={[{ required: true, message: "请选择负责部门" }]}
        >
          <Cascader
            fieldNames={{
              label: "name",
              value: "id",
              children: "children",
            }}
            options={deptList}
            onChange={changeDept}
            placeholder="请选择负责部门"
          />
        </Form.Item>
        <Form.Item
          label="处理人"
          name="handleUserIds"
          rules={[{ required: true, message: "请选择处理人" }]}
        >
          <Select mode="multiple" placeholder="请选择处理人">
            {personList.length > 0 &&
              personList.map((item) => {
                return (
                  <Select.Option value={item.id} key={item.id}>
                    {item.realName}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          label="工单内容"
          name="workOrderContent"
          rules={[{ required: true, message: "请填写工单内容" }]}
        >
          <Input.TextArea row={4} placeholder="请输入工单内容" />
        </Form.Item>
        <Form.Item
          label="截止时间"
          name="time"
          rules={[{ required: true, message: "请选择截止时间" }]}
        >
          <RangePicker
            disabledDate={(current) => disabledDate(current, timeLimit)}
            disabledTime={(current, type) =>
              disabledTime(current, type, timeLimit)
            }
            showTime
          />
        </Form.Item>
        <Form.Item label="上传图片">
          <Upload
            name="file"
            action={window.globalConfig.UPLOADER}
            headers={{ authorization: sessionStorage.getItem("token") }}
            beforeUpload={(e) => beforeUpload(e)}
            onChange={(e) => uploadResultImg(e)}
            onRemove={(e) => removeResultImg(e)}
          >
            <Button icon={<UploadOutlined />}>上传图片</Button>
          </Upload>
        </Form.Item>
      </Form>
    </AddModal>
  );
};
